import { Route, Routes } from 'react-router-dom'
import { AdminAirlinesPage } from './pages/AdminAirlinesPage'
import { AircargoHome } from './pages/AircargoHome'
import { AirratesHome } from './pages/AirratesHome'
import { ContactPage } from './pages/ContactPage'
import { DashboardPage } from './pages/DashboardPage'
import DevelopersPage from './pages/DevelopersPage'
import { PrivacyPage, TosPage } from './pages/LegalPage'
import { LoginPage } from './pages/LoginPage'
import UsagePage from './pages/UsagePage'
import { SURFACE } from './surface'

// Surface-branched routing. The home route differs per domain; everything else falls through to it.
// /developers is shared: the same air API + MCP docs page serves both aircargo and airrates surfaces.
export function App() {
  const Home = SURFACE === 'airrates' ? AirratesHome : AircargoHome
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/developers" element={<DevelopersPage />} />
      <Route path="/usage" element={<UsagePage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/tos" element={<TosPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/admin/airlines" element={<AdminAirlinesPage />} />
      <Route path="*" element={<Home />} />
    </Routes>
  )
}
